import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import './Dashboard.css';
import ApiService from '../utils/api';

function Dashboard() {
  const navigate = useNavigate();
  const { user, logout } = useContext(AuthContext);

  const handleLogout = () => {
    // Clear authentication data
    ApiService.logout();
    
    // Add a small delay to ensure state is cleared properly
    setTimeout(() => {
      // Force redirect to login page
      window.location.href = '/';
    }, 100);
  };

  return (
    <div className="dashboard">
      <header className="dashboard-header">
        <div className="container header-container">
          <div className="logo">
            <img src="/logo.png" alt="Company Logo" />
            <h1>Sistem Penggajian</h1>
          </div>
          <nav className="main-nav">
            <ul>
              <li className="active"><a href="/dashboard">Dashboard</a></li>
              <li><a href="/salary">Slip Gaji</a></li>
              <li><a href="/change-password">Ubah Password</a></li>
              {user && user.isAdmin && (
                <li><a href="/admin">Admin Panel</a></li>
              )}
            </ul>
          </nav>
          <div className="user-menu">
            <span className="username">{user ? user.name : 'User'}</span>
            <button 
              className="logout-btn"
              onClick={handleLogout}
            >
              Logout
            </button>
          </div>
        </div>
      </header>

      <main className="dashboard-content">
        <div className="container">
          <div className="welcome-card">
            <h2>Selamat Datang, {user ? user.name : 'User'}</h2>
            <p>Silahkan pilih menu yang tersedia untuk melanjutkan.</p>
          </div>

          <div className="dashboard-grid">
            <div className="dashboard-card" onClick={() => navigate('/salary')}>
              <div className="card-icon">💰</div>
              <h3>Slip Gaji</h3>
              <p>Lihat dan unduh slip gaji Anda</p>
            </div>
            
            <div className="dashboard-card" onClick={() => navigate('/change-password')}>
              <div className="card-icon">🔑</div>
              <h3>Ubah Password</h3>
              <p>Perbarui kata sandi akun Anda</p>
            </div>
            
            {user && user.isAdmin && (
              <div className="dashboard-card" onClick={() => navigate('/admin')}>
                <div className="card-icon">⚙️</div>
                <h3>Admin Panel</h3>
                <p>Kelola pengguna dan data sistem</p>
              </div>
            )}
          </div>
        </div>
      </main>

      <footer className="dashboard-footer">
        <div className="container">
          <p>&copy; {new Date().getFullYear()} Sistem Penggajian. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default Dashboard; 